import config from "/config.js";
const valenHrModuleDisplayName = config.modules.valenHr.displayName;
const valenHrModuleRoutePath = config.modules.valenHr.routePath;

const routes = [

	//---- Module: "Staff HR" (Valen HR module)
	{
		path: "/module/" + valenHrModuleRoutePath,
		name: "valen-hr-index",
		component: () => import("/module.valen-hr/index.vue"),
		meta: { layout: "primary", module: "valenHr", pageTitle: valenHrModuleDisplayName }
	},

	{
		path: "/module/" + valenHrModuleRoutePath + "/admin",
		name: "valen-hr-admin-index",
		component: () => import("/module.valen-hr/admin/index.vue"),
		meta: {
			layout: "primary",
			module: "valenHr",
			pageTitle: "Admin"
		},
		props: true
	},

	{
		path: "/module/" + valenHrModuleRoutePath + "/employee",
		name: "valen-hr-employee-index",
		props: true,
		component: () => import("/module.valen-hr/employee/index.vue"),
		meta: {
			layout: "primary",
			module: "valenHr",
			pageTitle: "My Dashboard"
		}
	},

	{
		path: "/module/" + valenHrModuleRoutePath + "/manager",
		redirect: { name: "valen-hr-manager-index" }
	},

	{
		path: "/module/" + valenHrModuleRoutePath + "/manager/dashboard",
		name: "valen-hr-manager-index",
		//component: () => import("/module.valen-hr/manager/index.vue"),
		component: () => import("/module.valen-hr/manager/pages/Dashboard.vue"),
		meta: {
			layout: "primary",
			module: "valenHr",
			pageTitle: "Manager Dashboard"
		},
		props: true,
		children: [
			// {
			// 	name: "valen-hr-manager-index-redirect",
			// 	path: "",
			// 	redirect: { name: "valen-hr-manager-index" }
			// },
			// {
			// 	path: "dashboard",
			// 	name: "valen-hr-manager-index",
			// 	meta: {
			// 		layout: "primary",
			// 		module: "valenHr",
			// 		pageTitle: "Manager Dashboard"
			// 	},
			// 	props: true,
			// 	component: () => import("/module.valen-hr/manager/pages/Dashboard.vue")
			// },
			//TODO: Obsolete.
			// {
			// 	path: "performance-reviews",
			// 	name: "valen-hr-manager-performance-reviews",
			// 	meta: {
			// 		layout: "primary",
			// 		module: "valenHr",
			// 		pageTitle: "Performance Reviews"
			// 	},
			// 	props: true,
			// 	component: import("/module.valen-hr/manager/pages/PerformanceReviews.vue")
			// }
		]
	},

	{
		path: "/module/" + valenHrModuleRoutePath + "/kudos",
		redirect: { name: "valen-hr-kudos" }
	},

	{
		path: "/module/" + valenHrModuleRoutePath + "/kudos/dashboard",
		name: "valen-hr-kudos",
		//component: () => import("/module.valen-hr/kudos/index.vue"),
		component: () => import("/module.valen-hr/kudos/pages/Dashboard.vue"),
		meta: {
			layout: "primary",
			module: "valenHr",
			pageTitle: "Kudos"
		},
		props: true,
		children: [
			// {
			// 	name: "valen-hr-kudos-index-redirect",
			// 	path: "",
			// 	redirect: { name: "valen-hr-kudos-index" }
			// },
			// {
			// 	path: "/module/" + valenHrModuleRoutePath + "/kudos/dashboard",
			// 	name: "valen-hr-kudos-index",
			// 	meta: {
			// 		layout: "primary",
			// 		module: "valenHr",
			// 		pageTitle: "Kudos"
			// 	},
			// 	props: true,
			// 	component: () => import("/module.valen-hr/kudos/pages/Dashboard.vue")
			// },
			// {
			// 	path: "/module/" + valenHrModuleRoutePath + "/kudos/user/:staffId",
			// 	name: "valen-hr-kudos-user",
			// 	meta: {
			// 		layout: "primary",
			// 		module: "valenHr",
			// 		pageTitle: "Give Kudos"
			// 	},
			// 	props: true,
			// 	component: () => import("/module.valen-hr/kudos/pages/UserKudos.vue")
			// }
		]
	},
	{
		path: "/module/" + valenHrModuleRoutePath + "/kudos/user/:staffId",
		name: "valen-hr-kudos-user",
		meta: {
			layout: "primary",
			module: "valenHr",
			pageTitle: "Give Kudos"
		},
		props: true,
		component: () => import("/module.valen-hr/kudos/pages/UserKudos.vue")
	},
	{
		path: "/module/" + valenHrModuleRoutePath + "/review",
		name: "valen-hr-review-index",
		component: () => import("/module.valen-hr/review/ReviewList.vue"),
		meta: {
			layout: "primary",
			module: "valenHr",
			pageTitle: "New Employee Review"
		},
		props: true
	},

	{
		path: "/module/" + valenHrModuleRoutePath + "/review/new/:staffId/:reviewId",
		name: "valen-hr-review-new",
		component: () => import("/module.valen-hr/review/ReviewPage.vue"),
		meta: {
			layout: "primary",
			module: "valenHr",
			pageTitle: "New Employee Review",
			// ReviewPage replaces the header title with the staff member's name and
			// review period; this keeps the breadcrumb trail reading the same either way.
			breadcrumbLabel: "New Employee Review"
		},
		props: true
	},
	{
		path: "/module/" + valenHrModuleRoutePath + "/review/edit/:staffId/:reviewId",
		name: "valen-hr-review-edit",
		component: () => import("/module.valen-hr/review/ReviewPage.vue"),
		meta: {
			layout: "primary",
			module: "valenHr",
			pageTitle: "Edit Employee Review",
			// ReviewPage replaces the header title with the staff member's name and
			// review period; this keeps the breadcrumb trail reading the same either way.
			breadcrumbLabel: "Edit Employee Review"
		},
		props: true
	},

	//TODO: This route is obsolete. See route with :staffId
	// {
	// 	path: "/module/" + valenHrModuleRoutePath + "/user-profile",
	// 	name: "valen-hr-user-profile-index",
	// 	component: () => import("/module.valen-hr/user-profile/index.vue"),
	// 	meta: {
	// 		layout: "primary",
	// 		module: "valenHr",
	// 		pageTitle: "User Profile"
	// 	},
	// 	props: true
	// },
	{
		path: "/module/" + valenHrModuleRoutePath + "/user-profile/:staffId",
		name: "valen-hr-user-profile",
		component: () => import("/module.valen-hr/user-profile/index.vue"),
		meta: {
			layout: "primary",
			module: "valenHr",
			pageTitle: "User Profile - {fullName}"
		},
		props: true
	},
		// Printable version (popup, via printPage())
		{
			path: "/module/" + valenHrModuleRoutePath + "/user-profile/:staffId/print",
			name: "valen-hr-user-profile-print",
			component: () => import("/module.valen-hr/user-profile/index.vue"),
			meta: {
				layout: "no",
				module: "valenHr",
				pageTitle: "User Profile"
			},
			props: true
		},

		// In-app "Report" screen - a routed preview of the same content the print popup shows.
		{
			path: "/module/" + valenHrModuleRoutePath + "/user-profile/:staffId/report",
			name: "valen-hr-user-profile-report",
			component: () => import("/module.valen-hr/user-profile/report.vue"),
			meta: {
				layout: "primary",
				module: "valenHr",
				pageTitle: "Performance Report"
			},
			props: true
		}
];

export default routes;
